import { render, staticRenderFns } from "./systemOuterFrameSetting.vue?vue&type=template&id=55a183aa&scoped=true&"
import script from "./systemOuterFrameSetting.vue?vue&type=script&lang=js&"
export * from "./systemOuterFrameSetting.vue?vue&type=script&lang=js&"
import style0 from "./systemOuterFrameSetting.vue?vue&type=style&index=0&id=55a183aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a183aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
